export default from './change-post-category-modal';



// WEBPACK FOOTER //
// ./app/containers/change-post-category-modal/index.js